import React from 'react';
import {
  ButtonComponent as Button,
  ButtonMode,
  DialogComponent,
  Box,
  CloseIcon,
  TitleText,
  ButtonSize
} from 'edenred-ui';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import { addDays, addYears } from 'date-fns';

import { ITerminationDateDialog } from '@epi-models/pages/Beneficiaries';

import { useTerminationDateDialog } from '../hooks';

import { TerminationDatePicker } from './TerminationDatePicker';
import { FormFields } from '@epi-forms/helpers';

const today = new Date();

export const TerminationDateDialog = ({
  isOpen,
  handleClose,
  isAddMode,
  handleSetDate,
  handleSave,
  endOfBenefit,
  disableSave,
  errorText,
  startDate,
  title,
  name
}: ITerminationDateDialog) => {
  const { gray10, sizeExtraExtraLarge } = useTheme();
  const { t } = useTranslation();
  useTerminationDateDialog(handleClose);

  const getBeforeDate = () => {
    if (!startDate) {
      return today;
    }

    if (name === FormFields.EndOfFunds) {
      return new Date(startDate);
    }

    if (
      (isAddMode && startDate) ||
      new Date(startDate).setHours(0, 0, 0, 0) >= today.setHours(0, 0, 0, 0)
    ) {
      return addDays(new Date(startDate), 1);
    }

    return today;
  };

  return (
    <DialogComponent open={isOpen} onClose={handleClose}>
      <Box pt={2} pl={5} borderBottom={1} borderColor={gray10} minWidth={400}>
        <Box position="absolute" right={16}>
          <Button
            id="date-range-dialog-cancel-btn"
            mode={ButtonMode.Link}
            onClick={handleClose}
            type="button"
          >
            <CloseIcon />
          </Button>
        </Box>
        <Box pt={3} maxWidth={250}>
          <TitleText fontWeight={600} fontSize={sizeExtraExtraLarge}>
            {title}
          </TitleText>
        </Box>
      </Box>
      <Box
        height={400}
        pt={2.5}
        pl={5}
        pr={5}
        borderBottom={1}
        borderColor={gray10}
        fontSize={16}
      >
        <TerminationDatePicker
          dayValue={isAddMode ? startDate : endOfBenefit}
          setTerminationDate={handleSetDate}
          isError={disableSave}
          errorText={errorText}
          title={t('containers.beneficiaries.detail.termination_modal_modal')}
          disabledCustomDates={
            startDate
              ? {
                  before: getBeforeDate(),
                  after: addYears(new Date(startDate), 2)
                }
              : undefined
          }
          disableByDefault
        />
      </Box>
      <Box
        display="flex"
        pt={2}
        justifyContent="flex-end"
        pr={5}
        gap={8}
        pb={2}
      >
        <Button
          id="date-range-dialog-cancel-btn"
          mode={ButtonMode.Link}
          onClick={handleClose}
          type="button"
        >
          {t('download_reports.lunch_deduction.time_period.dialog_cancel')}
        </Button>
        <Button
          id="date-range-dialog-save-btn"
          size={ButtonSize.Large}
          minWidth={135}
          mode={ButtonMode.Primary}
          disabled={disableSave}
          onClick={handleSave}
          type="button"
        >
          {t('download_reports.lunch_deduction.time_period.dialog_save')}
        </Button>
      </Box>
    </DialogComponent>
  );
};
